import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { SplashScreen } from 'src/components/splash-screen';
import { useCapabilities } from 'src/hooks/use-capabilities';
import { Capability } from 'src/types/user';

interface CapabilitiesGuardProps {
  capabilities: Capability[];
  validate: (capabilities: boolean[]) => boolean;
  redirect?: string;
}

/**
 * Guard redirects depending on user capabilities
 */
export const CapabilitiesGuard: FC<
  PropsWithChildren<CapabilitiesGuardProps>
> = (props) => {
  const { capabilities, validate, redirect, children } = props;
  const navigate = useNavigate();
  const can = useCapabilities(...capabilities);

  useEffect(
    () => {
      if (!validate(can)) {
        console.info('[capabilities-guard] Redirecting (due to capabilities)');
        // redirect to fallback page
        if (redirect) navigate(redirect);
      }
    },
    // IMPORTANT: redirect depends only on capabilities
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [can]
  );

  // waiting for redirect
  if (!can) return <SplashScreen />;

  // guard passed
  return <>{children}</>;
};
